
import { useState } from "react";
import { Column, ColumnId } from "./PartTableHeader";

export const useTableDrag = (columns: Column[], setColumns: (columns: Column[]) => void) => {
  // State to track drag operation
  const [draggedColumn, setDraggedColumn] = useState<ColumnId | null>(null);
  
  // Handle column drag start
  const handleDragStart = (columnId: ColumnId) => {
    setDraggedColumn(columnId);
  };
  
  // Handle column being dragged over another column
  const handleDragOver = (e: React.DragEvent<HTMLTableCellElement>, targetColumnId: ColumnId) => {
    e.preventDefault();
    // Only allow dragging if the target column is also draggable
    const targetColumn = columns.find(col => col.id === targetColumnId);
    if (!targetColumn?.draggable) return;
  };
  
  // Handle dropping a column onto another column
  const handleDrop = (targetColumnId: ColumnId) => {
    // Guard clause if there's no draggedColumn
    if (!draggedColumn) return;
    
    // Find the source and target column indices
    const sourceIndex = columns.findIndex(col => col.id === draggedColumn);
    const targetIndex = columns.findIndex(col => col.id === targetColumnId);
    
    // Skip if dropping on itself or target is not draggable
    if (sourceIndex === targetIndex || !columns[targetIndex].draggable) return;
    
    // Create a new array with the columns reordered
    const newColumns = [...columns];
    const [removed] = newColumns.splice(sourceIndex, 1);
    newColumns.splice(targetIndex, 0, removed);
    
    // Update the state with the new order
    setColumns(newColumns);
    
    // Reset dragged column
    setDraggedColumn(null);
  };
  
  return {
    handleDragStart,
    handleDragOver,
    handleDrop
  };
};
